var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatsdashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 360 360",
    style: {
      enableBackground: "new 0 0 360 360"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.ist0{fill-rule:evenodd;clip-rule:evenodd;fill:none;}\r\n\t.ist1{fill-rule:evenodd;clip-rule:evenodd;fill:currentColor;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -0.53,
    className: "ist0",
    width: 360,
    height: 360
  }), /*#__PURE__*/React.createElement("path", {
    className: "ist1",
    d: "M64.89,114.04h31.2v135.72h-31.2V114.04L64.89,114.04z M291.43,50.93H67.51c-11.07,0-21.14,4.49-28.43,11.73 h-0.01c-7.29,7.24-11.82,17.22-11.82,28.21v139.57c0,11,4.52,20.98,11.82,28.21h0.01c7.29,7.24,17.37,11.73,28.43,11.73h223.92 c11.07,0,21.14-4.49,28.43-11.73h0.01c7.29-7.24,11.82-17.21,11.82-28.21V90.88c0-10.99-4.53-20.97-11.82-28.21h-0.01 C312.57,55.43,302.49,50.93,291.43,50.93L291.43,50.93z M67.51,45.04c-12.72,0-24.27,5.16-32.64,13.46l0.01,0.01 C26.5,66.81,21.3,78.28,21.3,90.88v139.57c0,12.61,5.2,24.08,13.58,32.37l-0.01,0.01c8.37,8.31,19.93,13.47,32.64,13.47h81.32 v25.85h62.58V276.3h80.02c12.71,0,24.27-5.16,32.64-13.47l-0.01-0.01c8.38-8.3,13.58-19.77,13.58-32.37V90.88 c0-12.6-5.2-24.07-13.58-32.37l0.01-0.01c-8.37-8.3-19.93-13.46-32.64-13.46H67.51L67.51,45.04z M110.72,302.31h138.79v12.66 H110.72V302.31L110.72,302.31z M262.85,176.77h31.19v72.99h-31.19V176.77L262.85,176.77z M210.85,144.12h31.19v105.63h-31.19 V144.12L210.85,144.12z M162.57,69.22h31.2v180.54h-31.2V69.22L162.57,69.22z M114.66,96.75h31.19v153h-31.19V96.75z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatsdashboard);
export default __webpack_public_path__ + "static/media/statsdashboard.edaa1e21d623c367a17552c3c92b2b40.svg";
export { ForwardRef as ReactComponent };